import axios from 'axios';
import {
	utilityService
} from '@/services/utilityService.js';

export const geoService = {
	geocode
};

// #region geo

function geocode (postaddr) {
	var encodedAddr = encodeURIComponent(postaddr);
	return axios.post(utilityService.buildFullyQualifiedUrl(`geo/geocode?address=${encodedAddr}`),
		// Second parameter is the data/body
		{

		},
		// Third parameter is the configuration object
		{
			headers: utilityService.getHeaders()
		}
	)
}

// #endregion geo
